import { EtaLocation } from '@/feature/eta'
import { GEO_FEATURE_MARKER_COLOR, HIGH_RISK_MARKER_COLOR } from '@/feature/observatory'

import { MarkerBadge } from '@/components/MarkerBadge'
import { LuBolt, LuTriangleAlert } from 'react-icons/lu'

import styles from '../Eta.module.css'

export const GeofenceLocationFrom = ({ etaLocation }: { etaLocation: EtaLocation }) => (
  <div className={styles.locationFrom}>
    <div className={styles.locationFromTitle}>Geofence ID</div>
    <div className={styles.locationFromContent}>
      <div className={styles.locationFromContentTitle}>
        {etaLocation.highRiskArea ? (
          <MarkerBadge glyph={LuTriangleAlert} color={HIGH_RISK_MARKER_COLOR} size={28} />
        ) : (
          <div className={styles.geoFenceIcon}>
            <MarkerBadge glyph={LuBolt} size={22} color={GEO_FEATURE_MARKER_COLOR} />
          </div>
        )}

        {etaLocation?.title}
      </div>
    </div>
  </div>
)
